export class UserTag {

    id: number;

    tag: string;

}
